const concatUrl = (url) => {
    if ('development' === process.env.NODE_ENV) {
        return `http://simulateur.lasolutionarchibald.test/${url}`;
    }

    return url;
};

// const getBody = (params = {}) => {
//     const body = new FormData();
//
//     for (let [key, value] of Object.entries(params)) {
//         if (value instanceof Object && !(value instanceof File)) {
//             // eslint-disable-next-line no-param-reassign
//             value = JSON.stringify(value);
//         }
//         body.append(key, value);
//     }
//
//     return body;
// };

const getHeaders = () => {
    return new Headers();
};

export const get = (url) => fetch(concatUrl(url), {
    headers: getHeaders(),
});

// export const post = (url, params) => fetch(concatUrl(url), {
//     method: 'POST',
//     body: getBody(params),
//     headers: getHeaders(),
// });
//
// export const put = (url, params) => fetch(concatUrl(url), {
//     method: 'PUT',
//     body: getBody(params),
//     headers: getHeaders(),
// });
//
// export const del = (url) => fetch(concatUrl(url), {
//     method: 'DELETE',
//     headers: getHeaders(),
// });

export const handleResponse = (response) => {
    if (response.status >= 300) {
        return Promise.resolve({
            status: response.status,
        });
    } else {
        return response.json().then((res) => Promise.resolve(res));
    }
}



// WEBPACK FOOTER //
// ./src/utils/http.js